import React from 'react';
import { buildImagePath } from '../components/JobComponents/Company/Image/logo';
import { DEFAULT_PRICING_TABLE } from '../components/Includes/Constants/employers';
import SVGFromCloudinary from '../components/Elements/SVGFromCloudinary/SVGFromCloudinary';
import {
    getRandomIndex,
    defaultUserImages,
} from '../components/Includes/randomAuthorImageGenerator';
import { MYSTERY_WOMAN_IMAGE_PATH } from './images';

export const truncateWithEllipsis = (text, length, ellipses = true) => {
    if (!text || text.length < length) {
        return text;
    }

    const truncated = text.substr(0, length);
    const splitWord = truncated.split(' ');
    if (splitWord.length > 1) {
        delete splitWord[splitWord.length - 1];
    }
    return ellipses
        ? `${splitWord.join(' ').trim()}...`
        : `${splitWord.join(' ')}`;
};

/**
 * utility function for Employer Marketing's Pricing page
 */
export const getTableHeader = () => [
    {
        label: 'PROGRAM OFFERINGS',
        value: 'PROGRAM OFFERINGS',
    },
    {
        label: 'SILVER',
        value: 'SILVER',
    },
    {
        label: 'GOLD',
        value: 'GOLD',
    },
    {
        label: 'PLATINUM',
        value: 'PLATINUM',
    },
];

const purpleCheckImgSrc = '/v1579721153/icons/checkmark_active_purple.svg';
const greyCheckImgSrc = '/v1579721153/icons/checkmark_inactive_gray.svg';

export const PurpleCheck = () => (
    <SVGFromCloudinary
        className="table-boolean-true"
        alt="active checkmark"
        cloudinaryID={purpleCheckImgSrc}
    />
);

export const GreyCheck = () => (
    <SVGFromCloudinary
        className="table-boolean-false"
        alt="inactive checkmark"
        cloudinaryID={greyCheckImgSrc}
    />
);

export const formatPricingRowData = (
    rawPricingRowData = DEFAULT_PRICING_TABLE
) => {
    if (!Array.isArray(rawPricingRowData) || rawPricingRowData.length === 0) {
        return [];
    }

    const serializedRowData = rawPricingRowData.map((row, i) => {
        return row.map((item, j) => {
            if (j === 0) {
                return item.label;
            }

            if ((row[0].type === 'boolean') & (j !== 0)) {
                return item ? <PurpleCheck /> : <GreyCheck />;
            } else {
                return item;
            }
        });
    });

    return serializedRowData;
};
/**
 * end
 */

export const videoTypes = {
    YOUTUBE: 'youtube',
    CLOUDINARY: 'cloudinary',
};

export const getVideoType = (videoSrc = '') => {
    if (!videoSrc) {
        return null;
    }

    if (videoSrc.indexOf('youtube') >= 0 || videoSrc.indexOf('youtu.be') >= 0) {
        return videoTypes.YOUTUBE;
    }

    return videoTypes.CLOUDINARY;
};

export function intToMonth(int, short = false) {
    if (typeof int === 'string') int = parseInt(int, 10);
    if (int === 0) {
        console.error('intToMonth expects a 1-indexed month integer');
        return null;
    }

    if (short) {
        return [
            null,
            'Jan',
            'Feb',
            'March',
            'April',
            'May',
            'June',
            'July',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ][int];
    }

    return [
        null,
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ][int];
}

/*
    @TODO - there is duplication here with the author serializer on the server.
    Once the server's serializer is refactored, we should update this code 
    so that both the server and client use a shared function to serialize a user -MSH050120
*/
export const reserializeAuthor = (author, isAnon, session) => {
    if (isAnon) {
        return {
            ...author,
            userId: null,
            username: 'Anonymous',
            image: {
                alt: 'Anonymous image',
                src:
                    defaultUserImages[getRandomIndex(defaultUserImages.length)],
            },
            credential: null,
            karmaScore: null,
        };
    }

    return {
        ...author,
        userId: session.id,
        username: session.username,
        image: {
            alt: `${session.username} image`,
            src: session.logo || MYSTERY_WOMAN_IMAGE_PATH,
        },
        credential: session.credential,
        karmaScore: session.karma_score,
    };
};
